import { callAPI } from "./api.js";

const NOTIFICATION_ENDPOINT = "notifications";

function showMessage($store, type, message, { expiryTime = 5000, key = null } = {}) {
  return $store.dispatch('addMessage', { type, label: message, expiryTime, key });
}

export function showError($store, message, options) {
  return showMessage($store, 'error', message, options);
}

export function showSuccess($store, message, options) {
  return showMessage($store, 'success', message, options);
}

export function showInfo($store, message, options) {
  return showMessage($store, 'info', message, options);
}

export function showWarning($store, message, options) {
  return showMessage($store, 'warning', message, options);
}

export const notificationMixins = {
  methods: {
    async fetchNotifications(options = {}) {
      if (this.callAPI) {
        return await this.callAPI(NOTIFICATION_ENDPOINT, {
          method: "GET",
          showLoader: false,
          ...options,
        });
      }
      return await callAPI(this.$store, NOTIFICATION_ENDPOINT, {
        method: "GET",
        showLoader: false,
        ...options,
      });
    },
    async dismissNotification(id) {
      if (this.callAPI) {
        await this.callAPI(`${NOTIFICATION_ENDPOINT}/${id}/dismiss`, {
          method: "POST",
          showLoader: false,
        });
        return;
      }
      await callAPI(this.$store, `${NOTIFICATION_ENDPOINT}/${id}/dismiss`, {
        method: "POST",
        showLoader: false,
      });
    },
    displayNotification(notification) {
      const options = {
        expiryTime: notification.autoDismiss ? 30000 : 86400000,
      };
      if (notification.state === 'SUCCESS') {
        this.showSuccess(notification.message, options);
      } else if (notification.state === 'INFO') {
        this.showInfo(notification.message, options);
      } else if (notification.state === 'WARNING') {
        this.showWarning(notification.message, options);
      } else if (notification.state === 'FAILURE' || notification.state === 'ERROR') {
        this.showError(notification.message, options);
      }
    },
    async fetchAndDisplayNotifications(options = {}) {
      const notifications = await this.fetchNotifications(options);
      if (!Array.isArray(notifications)) {
        return;
      }
      for (const notification of notifications) {
        this.displayNotification(notification);
        await this.dismissNotification(notification.id);
      }
    },
    showError(message, options) {
      return showError(this.$store, message, options);
    },
    showSuccess(message, options) {
      return showSuccess(this.$store, message, options);
    },
    showInfo(message, options) {
      return showInfo(this.$store, message, options);
    },
    showWarning(message, options) {
      return showWarning(this.$store, message, options);
    },
  },
};
